module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Playlist2-1753b4491fb7d28de82c421b177554a9.svg";